import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {
  PrepaidSharingPricePlanModel
} from '../../prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/models/prepaid-sharing-price-plan.model';
import {RouteLibraryService} from '../../route/route-library.service';
import {RouteLibraryEntities} from '../../route/route-library-entity';

@Component({
  selector: 'app-prepaid-sharing-price-plan-card',
  templateUrl: './prepaid-sharing-price-plan-card.component.html',
})
export class PrepaidSharingPricePlanCardComponent implements OnInit {
  @HostBinding('class.price-plan-card-container') true;
  @Input() pricePlan: PrepaidSharingPricePlanModel;
  constructor(
    public routeLibraryService: RouteLibraryService
  ) { }

  ngOnInit() {
  }

  getLink() {
    return this.routeLibraryService.getRoute({
      entity: RouteLibraryEntities.PREPAID_SHARING_PRICE_PLAN,
      action: 'view',
      id: this.pricePlan.id
    });
  }
}
